import { render, staticRenderFns } from "./ChateRoom.vue?vue&type=template&id=1adef3e9&scoped=true&"
import script from "./ChateRoom.vue?vue&type=script&lang=js&"
export * from "./ChateRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChateRoom.vue?vue&type=style&index=0&id=1adef3e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adef3e9",
  null
  
)

export default component.exports